import { API } from '../../lib/ortam';

// Müşteri paneli istekleri (2026-10-26) — yalnız /api/musteri/* (müşteri token'ı başka yolda 403
// `musteri_yetkisiz` alır; services/auth tokenDogrula varsayılan reddet kapısı). Hata gövdesi
// (`hata`, `red`, `red_nedeni`) Error üzerinde taşınır: sepet/sipariş reddi soru numaralarıyla gösterilir.
export function musteriApi(authFetch) {
  const iste = async (yol, { method = 'GET', govde } = {}) => {
    const r = await authFetch(`${API}/api/musteri${yol}`, {
      method, ...(govde !== undefined ? { body: JSON.stringify(govde) } : {}),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) {
      const e = new Error(j.hata || `İstek başarısız (HTTP ${r.status})`);
      e.durum = r.status;
      e.govde = j;
      throw e;
    }
    return j;
  };
  return {
    profil: () => iste('/profil'),
    kazanim: (ders, mufredat) => iste(`/kazanim?${new URLSearchParams({ ders, ...(mufredat ? { mufredat } : {}) })}`),
    sorular: (suzgec, sayfa) => iste(`/sorular?${sorguMetni(suzgec, sayfa)}`),
    sekil: (no) => iste(`/sorular/${no}/sekil`),
    sepet: () => iste('/sepet'),
    sepeteEkle: (nolar) => iste('/sepet', { method: 'POST', govde: { public_nolar: nolar } }),
    sepettenCikar: (no) => iste(`/sepet/${no}`, { method: 'DELETE' }),
    sepetiBosalt: () => iste('/sepet', { method: 'DELETE' }),
    siparisVer: (not) => iste('/siparis', { method: 'POST', govde: not ? { not } : {} }),
    siparisler: () => iste('/siparisler'),
    siparis: (id) => iste(`/siparisler/${id}`),
  };
}

/**
 * Süzgeç durumu -> sorgu dizgisi (boş alan gönderilmez). Süzgeçler kutulu çoklu seçimdir (dizi):
 * ders, kazanım ve puan virgülle; iki değerli süzgeçler (müfredat, görsel, bağlam) yalnız TEK seçimde
 * gider — ikisi birden seçiliyse süzgeç yoktur.
 */
export function sorguMetni(s, sayfa = 1) {
  const p = new URLSearchParams();
  const liste = (v) => (Array.isArray(v) ? v : (v ? [v] : []));
  const tek = (v) => { const l = liste(v); return l.length === 1 ? l[0] : ''; };
  if (liste(s.ders).length) p.set('ders', liste(s.ders).join(','));
  if (tek(s.mufredat)) p.set('mufredat', tek(s.mufredat));
  if (liste(s.kazanim).length) p.set('kazanim_kodu', liste(s.kazanim).join(','));
  if (liste(s.puan).length) p.set('puan', liste(s.puan).join(','));
  if (tek(s.gorsel)) p.set('gorsel', tek(s.gorsel));
  if (tek(s.baglam)) p.set('baglam', tek(s.baglam));
  if (s.q && s.q.trim().length >= 2) p.set('q', s.q.trim());
  if (sayfa > 1) p.set('sayfa', String(sayfa));
  return p.toString();
}
